export default __webpack_public_path__ + "static/media/logo_tidings.6ce7853b.svg";